export default "__VITE_ASSET__7CKojKGN__"